var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-company", {
                          attrs: {
                            model: _vm.model.company_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.company_id,
                            label: "Empresa*",
                            "auto-complete": "",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "company_id", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.initials,
                            label: "Sigla*",
                          },
                          model: {
                            value: _vm.model.initials,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "initials", $$v)
                            },
                            expression: "model.initials",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.business_unit,
                            label: "Unidade Negócio",
                          },
                          model: {
                            value: _vm.model.business_unit,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "business_unit", $$v)
                            },
                            expression: "model.business_unit",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          directives: [
                            { name: "mask-cnpj", rawName: "v-mask-cnpj" },
                          ],
                          attrs: {
                            "error-messages": _vm.errors.cnpj,
                            label: "Cnpj",
                          },
                          model: {
                            value: _vm.model.cnpj,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cnpj", $$v)
                            },
                            expression: "model.cnpj",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.identifier_code,
                            label: "Identificador",
                          },
                          model: {
                            value: _vm.model.identifier_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "identifier_code", $$v)
                            },
                            expression: "model.identifier_code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            label: "Descrição",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.model.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "description", $$v)
                            },
                            expression: "model.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: _vm.hasIntegration(6) ? 4 : 6,
                        },
                      },
                      [
                        _c("s-switch", {
                          attrs: { inset: "", label: "Folha de Ponto" },
                          model: {
                            value: _vm.model.generate_time_sheet,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "generate_time_sheet", $$v)
                            },
                            expression: "model.generate_time_sheet",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.hasIntegration(6)
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                inset: "",
                                label: "Integra com a folha",
                              },
                              model: {
                                value: _vm.model.integrate_payroll,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "integrate_payroll", $$v)
                                },
                                expression: "model.integrate_payroll",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: _vm.hasIntegration(6) ? 4 : 6,
                        },
                      },
                      [
                        _c("v-switch", {
                          attrs: { color: "purple", inset: "", label: "Ativo" },
                          model: {
                            value: _vm.model.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "active", $$v)
                            },
                            expression: "model.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }